import { render, staticRenderFns } from "./EmergencyAlarm.vue?vue&type=template&id=b0573dc0&scoped=true&"
import script from "./EmergencyAlarm.vue?vue&type=script&lang=js&"
export * from "./EmergencyAlarm.vue?vue&type=script&lang=js&"
import style0 from "./EmergencyAlarm.vue?vue&type=style&index=0&id=b0573dc0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0573dc0",
  null
  
)

export default component.exports